import {
  GetLocationsRequest,
  Location,
  AddEditLocationRequest,
  BulkUpdateLocationRequest,
  EditLocationCalculateETARequest,
  GetPlanJobsLocationsRequest,
  GetLocationIdsRequest,
  PlanJobsLocationsListResponse,
  RemoveOrUnassignedLocationsRequest,
  LocationUpdateNotification,
  UpdateLocationsFromMlsRequest,
  RemoveLocationRequest,
  GetLocationLookupRequest,
  LocationLookup,
  BaseDataGridRequest,
} from '../domain';
import { Observable } from 'rxjs';
import { BaseGridResponse } from '../../data/shared/base-grid.response';
import { BaseRequest } from '../../data/shared/base.request';
import { updateLocationAgainstSegment } from '../domain/requests/jobs/update-location-against-segment.request';
import { UpdateLocationDetailRequest } from '../domain/requests/locations/update-location-details-request';
import { LocationTag } from '../domain/models/location-tag';

export abstract class LocationsRepository {
  abstract getLocations(
    request: BaseRequest<GetLocationsRequest>
  ): Observable<BaseGridResponse<Location>>;

  abstract bulkUpdateLocation(
    request: BulkUpdateLocationRequest
  ): Observable<boolean>;
  abstract editLocationCalculateJobETA(
    request: EditLocationCalculateETARequest
  ): Observable<boolean>;

  abstract editLocation(request: AddEditLocationRequest): Observable<boolean>;

  abstract deleteLocationFromJob(request: string): Observable<boolean>;

  abstract getLocationById(request: string): Observable<Location>;

  abstract GetLocationBySegmentId(request: GetLocationIdsRequest): Observable<Location[]>;

  abstract getUnAssignedLocations(request: string): Observable<Location[]>;

  abstract GetPlanAndJobsLocations(
    request: GetPlanJobsLocationsRequest
  ): Observable<PlanJobsLocationsListResponse>;

  abstract updatePlanLocation(
    request: AddEditLocationRequest
  ): Observable<boolean>;

  abstract updateLocationDetail(
    request: UpdateLocationDetailRequest[]
  ): Observable<boolean>;

  abstract getLocationsByPlanId(request: string): Observable<Location[]>;
  abstract removeLocation(request: RemoveLocationRequest): Observable<boolean>;
  abstract unassignLocation(request: RemoveLocationRequest): Observable<boolean>;
  abstract deleteAllUnAssignedLocation(request: string): Observable<boolean>;
  abstract removeOrUnassignedLocations(request: RemoveOrUnassignedLocationsRequest): Observable<boolean>;
  abstract deleteUnassignedLocations(request: RemoveOrUnassignedLocationsRequest[]): Observable<boolean>;
  abstract updatePlanLocationAgainstSegment(
    request: updateLocationAgainstSegment
  ): Observable<boolean>;

  abstract getTagsMLS(): Observable<LocationTag[] | undefined>;
  abstract getLookupLocationsByJobId(request: GetLocationLookupRequest): Observable<LocationLookup[]>;
  abstract getLocationUpdatesNotification(request: BaseDataGridRequest) :Observable<LocationUpdateNotification[]>;

  abstract updateLocationFromMls(request : UpdateLocationsFromMlsRequest): Observable<Response>;

}
